const constants = {
  ALERT_ERROR: 'error',
  ALERT_SUCCESS: 'success',
  ALERT_WARNING: 'warning',
  ALERT_INFO: 'info',
  colors: {
    primary: '#344153',
  },
  ROLE_ADMIN: 'admin',
  ROLE_SUPERVISOR: 'supervisor',
  ROLE_TENDEDOR: 'tendedor',
  ROLE_PATRONISTA: 'patronista',
  ROLE_CLIENTE: 'cliente',
  ROLE_ESTAMPADOR: 'estampador',
  ROLE_AUXILIAR: 'auxiliar',
  ROLE_INGENIERIA: 'ingenieria',
  ROLE_INVENTARIOS: 'inventarios',
  SCOPE_USER_CREATE: 'users:create',
  SCOPE_USER_READ: 'users:read',
  SCOPE_USER_UPDATE: 'users:update',
  SCOPE_USER_DELETE: 'users:delete',
  SCOPE_STOCK_SETTINGS_CREATE: 'stock.settings:create',
  SCOPE_STOCK_SETTINGS_READ: 'stock.settings:read',
  SCOPE_STOCK_SETTINGS_UPDATE: 'stock.settings:update',
  SCOPE_STOCK_SETTINGS_DELETE: 'stock.settings:delete',
  SCOPE_STOCK_CREATE: 'stock:create',
  SCOPE_STOCK_READ: 'stock:read',
  SCOPE_STOCK_UPDATE: 'stock:update',
  SCOPE_STOCK_DELETE: 'stock:delete',
  SCOPE_REPORTS_READ: 'reports:read',
  SCOPE_REPORTS_CREATE: 'reports:create',
  SCOPE_REPORTS_UPDATE: 'reports:update',
  SCOPE_REPORTS_DELETE: 'reports:delete',
  SCOPE_PROFILE_READ: 'profile:read',
  SCOPE_PROFILE_UPDATE: 'profile:update',
  SCOPE_TRANSACTIONS_READ: 'transactions:read',
  SCOPE_TRANSACTIONS_CREATE: 'transactions:create',
  SCOPE_TRANSACTIONS_UPDATE: 'transactions:update',
  SCOPE_TRANSACTIONS_DELETE: 'transactions:delete',
  SCOPE_PURCHASE_ORDERS_CREATE: 'purchases:create',
  SCOPE_PURCHASE_ORDERS_READ: 'purchases:read',
  SCOPE_PURCHASE_ORDERS_UPDATE: 'purchases:update',
  SCOPE_PURCHASE_ORDERS_DELETE: 'purchases:delete',

  CURRENCY_LIST: [
    { code: 'AED', name: 'Dirham de los Emiratos Árabes Unidos' },
    { code: 'AFN', name: 'Afghani afgano' },
    { code: 'ALL', name: 'Lek albanés' },
    { code: 'AMD', name: 'Dram armenio' },
    { code: 'ANG', name: 'Florín de las Antillas Neerlandesas' },
    { code: 'AOA', name: 'Kwanza angoleño' },
    { code: 'ARS', name: 'Peso argentino' },
    { code: 'AUD', name: 'Dólar australiano' },
    { code: 'AWG', name: 'Florín de Aruba' },
    { code: 'AZN', name: 'Manat azerí' },
    { code: 'BAM', name: 'Marco convertible de Bosnia-Herzegovina' },
    { code: 'BBD', name: 'Dólar de Barbados' },
    { code: 'BDT', name: 'Taka de Bangladesh' },
    { code: 'BGN', name: 'Lev búlgaro' },
    { code: 'BHD', name: 'Dinar bahreiní' },
    { code: 'BIF', name: 'Franco de Burundi' },
    { code: 'BMD', name: 'Dólar de Bermudas' },
    { code: 'BND', name: 'Dólar de Brunéi' },
    { code: 'BOB', name: 'Boliviano' },
    { code: 'BRL', name: 'Real brasileño' },
    { code: 'BSD', name: 'Dólar de las Bahamas' },
    { code: 'BTN', name: 'Ngultrum de Bután' },
    { code: 'BWP', name: 'Pula botsuano' },
    { code: 'BYN', name: 'Rublo bielorruso' },
    { code: 'BZD', name: 'Dólar de Belice' },
    { code: 'CAD', name: 'Dólar canadiense' },
    { code: 'CDF', name: 'Franco congoleño' },
    { code: 'CHF', name: 'Franco suizo' },
    { code: 'CLP', name: 'Peso chileno' },
    { code: 'CNY', name: 'Yuan chino' },
    { code: 'COP', name: 'Peso colombiano' },
    { code: 'CRC', name: 'Colón costarricense' },
    { code: 'CUC', name: 'Peso convertible cubano' },
    { code: 'CUP', name: 'Peso cubano' },
    { code: 'CVE', name: 'Escudo de Cabo Verde' },
    { code: 'CZK', name: 'Corona checa' },
    { code: 'DJF', name: 'Franco de Yibuti' },
    { code: 'DKK', name: 'Corona danesa' },
    { code: 'DOP', name: 'Peso dominicano' },
    { code: 'DZD', name: 'Dinar argelino' },
    { code: 'EGP', name: 'Libra egipcia' },
    { code: 'ERN', name: 'Nakfa eritreo' },
    { code: 'ETB', name: 'Birr etíope' },
    { code: 'EUR', name: 'Euro' },
    { code: 'FJD', name: 'Dólar fiyiano' },
    { code: 'FKP', name: 'Libra malvinense' },
    { code: 'GBP', name: 'Libra esterlina' },
    { code: 'GEL', name: 'Lari georgiano' },
    { code: 'GHS', name: 'Cedi ghanés' },
    { code: 'GIP', name: 'Libra de Gibraltar' },
    { code: 'GMD', name: 'Dalasi gambiano' },
    { code: 'GNF', name: 'Franco guineano' },
    { code: 'GTQ', name: 'Quetzal guatemalteco' },
    { code: 'GYD', name: 'Dólar guyanés' },
    { code: 'HKD', name: 'Dólar de Hong Kong' },
    { code: 'HNL', name: 'Lempira hondureño' },
    { code: 'HRK', name: 'Kuna croata' },
    { code: 'HTG', name: 'Gourde haitiano' },
    { code: 'HUF', name: 'Forint húngaro' },
    { code: 'IDR', name: 'Rupia indonesia' },
    { code: 'ILS', name: 'Nuevo sheqel israelí' },
    { code: 'INR', name: 'Rupia india' },
    { code: 'IQD', name: 'Dinar iraquí' },
    { code: 'IRR', name: 'Rial iraní' },
    { code: 'ISK', name: 'Corona islandesa' },
    { code: 'JMD', name: 'Dólar jamaiquino' },
    { code: 'JOD', name: 'Dinar jordano' },
    { code: 'JPY', name: 'Yen japonés' },
    { code: 'KES', name: 'Chelín keniano' },
    { code: 'KGS', name: 'Som kirguís' },
    { code: 'KHR', name: 'Riel camboyano' },
    { code: 'KMF', name: 'Franco comoriano' },
    { code: 'KPW', name: 'Won norcoreano' },
    { code: 'KRW', name: 'Won surcoreano' },
    { code: 'KWD', name: 'Dinar kuwaití' },
    { code: 'KYD', name: 'Dólar de las Islas Caimán' },
    { code: 'KZT', name: 'Tenge kazajo' },
    { code: 'LAK', name: 'Kip laosiano' },
    { code: 'LBP', name: 'Libra libanesa' },
    { code: 'LKR', name: 'Rupia de Sri Lanka' },
    { code: 'LRD', name: 'Dólar liberiano' },
    { code: 'LSL', name: 'Loti lesothense' },
    { code: 'LYD', name: 'Dinar libio' },
    { code: 'MAD', name: 'Dírham marroquí' },
    { code: 'MDL', name: 'Leu moldavo' },
    { code: 'MGA', name: 'Ariary malgache' },
    { code: 'MKD', name: 'Dinar macedonio' },
    { code: 'MMK', name: 'Kyat birmano' },
    { code: 'MNT', name: 'Tugrik mongol' },
    { code: 'MOP', name: 'Pataca de Macao' },
    { code: 'MRO', name: 'Uguiya mauritana' },
    { code: 'MUR', name: 'Rupia mauriciana' },
    { code: 'MVR', name: 'Rupia de Maldivas' },
    { code: 'MWK', name: 'Kwacha malauí' },
    { code: 'MXN', name: 'Peso mexicano' },
    { code: 'MYR', name: 'Ringgit malasio' },
    { code: 'MZN', name: 'Metical mozambiqueño' },
    { code: 'NAD', name: 'Dólar namibio' },
    { code: 'NGN', name: 'Naira nigeriano' },
    { code: 'NIO', name: 'Córdoba nicaragüense' },
    { code: 'NOK', name: 'Corona noruega' },
    { code: 'NPR', name: 'Rupia nepalesa' },
    { code: 'NZD', name: 'Dólar neozelandés' },
    { code: 'OMR', name: 'Rial omaní' },
    { code: 'PAB', name: 'Balboa panameño' },
    { code: 'PEN', name: 'Sol peruano' },
    { code: 'PGK', name: 'Kina papú' },
    { code: 'PHP', name: 'Peso filipino' },
    { code: 'PKR', name: 'Rupia pakistaní' },
    { code: 'PLN', name: 'Złoty polaco' },
    { code: 'PYG', name: 'Guaraní paraguayo' },
    { code: 'QAR', name: 'Riyal qatarí' },
    { code: 'RON', name: 'Leu rumano' },
    { code: 'RSD', name: 'Dinar serbio' },
    { code: 'RUB', name: 'Rublo ruso' },
    { code: 'RWF', name: 'Franco ruandés' },
    { code: 'SAR', name: 'Riyal saudí' },
    { code: 'SBD', name: 'Dólar de las Islas Salomón' },
    { code: 'SCR', name: 'Rupia de Seychelles' },
    { code: 'SDG', name: 'Dinar sudanés' },
    { code: 'SEK', name: 'Corona sueca' },
    { code: 'SGD', name: 'Dólar de Singapur' },
    { code: 'SHP', name: 'Libra de Santa Elena' },
    { code: 'SLL', name: 'Leone de Sierra Leona' },
    { code: 'SOS', name: 'Chelín somalí' },
    { code: 'SRD', name: 'Dólar surinamés' },
    { code: 'SSP', name: 'Libra sursudanesa' },
    { code: 'STD', name: 'Dobra de Santo Tomé y Príncipe' },
    { code: 'SVC', name: 'Colón salvadoreño' },
    { code: 'SYP', name: 'Libra siria' },
    { code: 'SZL', name: 'Lilangeni suazi' },
    { code: 'THB', name: 'Baht tailandés' },
    { code: 'TJS', name: 'Somoni tayiko' },
    { code: 'TMT', name: 'Manat turcomano' },
    { code: 'TND', name: 'Dinar tunecino' },
    { code: 'TOP', name: 'Paʻanga tongano' },
    { code: 'TRY', name: 'Lira turca' },
    { code: 'TTD', name: 'Dólar de Trinidad y Tobago' },
    { code: 'TWD', name: 'Nuevo dólar taiwanés' },
    { code: 'TZS', name: 'Chelín tanzano' },
    { code: 'UAH', name: 'Grivna ucraniana' },
    { code: 'UGX', name: 'Chelín ugandés' },
    { code: 'USD', name: 'Dólar estadounidense' },
    { code: 'UYU', name: 'Peso uruguayo' },
    { code: 'UZS', name: 'Som uzbeko' },
    { code: 'VEF', name: 'Bolívar venezolano' },
    { code: 'VND', name: 'Dong vietnamita' },
    { code: 'VUV', name: 'Vatu vanuatuense' },
    { code: 'WST', name: 'Tala samoana' },
    { code: 'XAF', name: 'Franco CFA de África Central' },
    { code: 'XCD', name: 'Dólar del Caribe Oriental' },
    { code: 'XOF', name: 'Franco CFA de África Occidental' },
    { code: 'XPF', name: 'Franco CFP' },
    { code: 'YER', name: 'Rial yemení' },
    { code: 'ZAR', name: 'Rand sudafricano' },
    { code: 'ZMW', name: 'Kwacha zambiano' },
    { code: 'ZWL', name: 'Dólar de Zimbabue' },
  ],
};

export default constants;
